export default "__VITE_ASSET__BSh4Ljs1__"